import i18next from "i18next"
import React, { createContext, useContext, useEffect, useState } from "react"

const LanguageContext = createContext({
  language: "vi",
  changeLanguage: (lang: string) => {},
})

export const LanguageProvider = ({ children }: { children: React.ReactNode }) => {
  const [language, setLanguage] = useState(localStorage.getItem("language") ?? "vi")

  const changeLanguage = (lang: string) => {
    setLanguage(lang)
    i18next.changeLanguage(lang)
    localStorage.setItem("language", lang)
    window.location.reload()
  }

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language")
    if (savedLanguage) {
      setLanguage(savedLanguage)
      i18next.changeLanguage(savedLanguage)
    }
  }, [])

  return <LanguageContext.Provider value={{ language, changeLanguage }}>{children}</LanguageContext.Provider>
}

export const useLanguage = () => useContext(LanguageContext)
